import React, { useReducer } from 'react';
import DmServicesReducer from './dmServicesReducer';
import DmServicesContext from './dmServicesContext';

const DmServicesState = (props) => {
  const initialState = {
    messageData: null,
    customerData: null,
  };

  const [state, dispatch] = useReducer(DmServicesReducer, initialState);

  return (
    <DmServicesContext.Provider value={[state, dispatch]}>
      {props.children}
    </DmServicesContext.Provider>
  );
};

export default DmServicesState;
